import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import { Navigation } from 'swiper/modules';

function ServicePreviewSwiper() {
  const [services, setServices] = useState([]);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}/service`)
      .then(res => setServices(res.data))
      .catch(err => console.error(err));
  }, []);

  return (
    <div className="py-12 px-4 md:px-20 bg-white">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-3xl font-bold font-ec text-textPrimary mb-8">我們的服務</h2>
        <Swiper
          modules={[Navigation]}
          spaceBetween={20}
          slidesPerView={1}
          navigation
          breakpoints={{
            640: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
        >
          {services.map((item, idx) => (
            <SwiperSlide key={idx}>
              <div
                className="p-6  rounded-xl shadow h-[150px] flex flex-col justify-between border"
                style={{ borderColor: '#D8C4B6' }}
              >
                {/* 上半部：Icon + Title */}
                <div>
                  <h3 className="text-xl font-bold font-ec text-textPrimary mb-2 flex items-center space-x-2">
                    <i className={`${item.imageUrl} text-2xl text-secondary`} />
                    <span>{item.title}</span>
                  </h3>
                </div>

                {/* 下半部：固定高度描述區塊 */}
                <div className="mt-2 text-sm font-ec text-textSecondary" style={{ minHeight: '60px' }}>
                  {item.description}
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}

export default ServicePreviewSwiper;
